module.exports = __webpack_public_path__ + "img/99-038b9c.png";